import { Button, Card, CardActions, CardContent, CardHeader, Checkbox, FormControlLabel, CircularProgress, Divider, Grid, Snackbar, TextField, Typography } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import GenericAnket from 'src/components/GenericSurvey';
import { generateCode, getLastSms, setLastSms } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import CustomerPermision from './Summary/CustomerPermision';
const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    backgroundColor: '#424242',
    width: '100%'
  },
  content: {
    minHeight: 430,
  },
}));
function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
      guide={false}
    />
  );
}
TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};
function Dogrulama({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [farkliSms, setFarkliSms] = useState(false);
  const [aliciAd, setAliciAd] = useState('');
  const [aliciSoyad, setAliciSoyad] = useState('');
  const [aliciGsm, setAliciGsm] = useState('');
  const [aliciGsmTxt, setAliciGsmTxt] = useState('');
  const [smsKod, setSmsKod] = useState('');

  const [needSmsValidation, setNeedSmsValidation] = useState(true);
  const [needSmsResult, setNeedSmsResult] = useState('');
  const [alertVal, setAlertVal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [smsSent, setSmsSent] = useState(false);
  const [smsSentCount, setSmsSentCount] = useState(1);
  const [openEdit, setOpenEdit] = useState(false);
  const [anketOpen, setAnketOpen] = React.useState(true);
  const [anketKapandi, setAnketKapandi] = React.useState(false);
  const handleEditClose = () => {
    setOpenEdit(false);
    clearSurveyResult();
  }
  const openAlertMessage = (text, messageType) => {
    setAlertMessage(text);
    setAlertVal(true);
    setAlertType(messageType);
  };
  const validPhone = (value) => /(5([0-9]{9}))$/.test(value);
  const isButtonEnable = (!farkliSms
    || (farkliSms
      && aliciAd.length > 0
      && aliciSoyad.length > 0
      && validPhone(aliciGsm)));

  const [farkliTelErrorText, setFarkliTelErrorText] = useState('');
  const [farkliTelAdErrorText, setFarkliTelAdErrorText] = useState('');
  const [farkliTelSoyadErrorText, setFarkliTelSoyadErrorText] = useState('');
  const [loadingControl, setLoadingControl] = useState(true);
  const handleSubmit = (event) => event.preventDefault();

  const taskArray = Array.isArray(tasks?.tasks) ? tasks.tasks : [];
  const localJobArray = Array.isArray(loadBaslandiJob()) ? loadBaslandiJob() : [];

  const DogrulamaData = readonly
    ? taskArray.filter(d => Number(d?.FisNo) === Number(FisNo))
    : localJobArray;



  const changeSmsKontrol = (value) => {
    if (readonly) {
      return;
    }
    const jobs = loadBaslandiJob();
    if (!Array.isArray(jobs) || jobs.length === 0) return;
    
    let job = jobs[0];
    job = {
      ...job,
      SMS_DOGRULAMA: value,
    }
    saveBaslandiJob(job);
  }
  const clearSurveyResult = () => {
    const reqData = {
      FisNo,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetDeleteSurveyWithServicePaperNr', { jsonString: JSON.stringify(reqData) }, config).then((response) => {
      let respData = response.data;
      if (respData.ErrorCode === "0") {
        openAlertMessage(respData.ErrorDescription, 'success');
      }
      else {
        openAlertMessage(respData.ErrorDescription, 'error');
      }
    });
  }
  React.useEffect(() => {


    // Her renderda burası kaybolacağı için commentlendi
    // if (DogrulamaData[0]?.KVKK_DOGRULAMA) {
    //   readonly = true;
    // }

    const firstItem = (Array.isArray(DogrulamaData) && DogrulamaData.length > 0) ? DogrulamaData[0] : {};

    setFarkliSms(firstItem?.FARKLI_SMS || false);
    setAliciAd(firstItem?.SMS_ALICI_ADI || '');
    setAliciSoyad(firstItem?.SMS_ALICI_SOYADI || '');
    setAliciGsm(firstItem?.ALICI_GSM || '');
    setAliciGsmTxt(firstItem?.ALICI_GSM || '');
    setSmsKod(firstItem?.ALINAN_SMS_KOD || '');

    if (readonly) {
      setLoadingControl(false);
      return;
    }


    const data = {
      PRODUCT_ID: String(firstItem?.KUL_MODEL_KODU || '0'),
      SERVICE_SHOPID: String(firstItem?.BIRIM_KODU || '0'),
      STATUS: String(firstItem?.DURUM_KODU || '0'),
      SERVICEPAPER_NR: String(firstItem?.FisNo || '0'),
      WARRANTY_TYPE: String(firstItem?.GARANTI_TIPI ?? '0'),
      APPNR: String(firstItem?.BasvuruNo || '0'),
      TECHNICIAN_ID: String(firstItem?.TEKNISYEN_KODU || '0'),

      HIZMET: Array.isArray(firstItem?.HIZMETLER)
        ? firstItem.HIZMETLER.map(h => ({
          HIZMET_KODU: Number(h.HIZMET_KODU)
        }))
        : [],

      ISCILIKLER: Array.isArray(firstItem?.ISCILIKLER)
        ? firstItem.ISCILIKLER.map(i => ({
          ISCILIK_KODU: Number(i.ISCILIK_KODU),
          HIZMET_KODU: Number(i.HIZMET_KODU),
          KUL_ISCILIK_KODU: String(i.KUL_ISCILIK_KODU || ''),
          ACIKLAMA: String(i.ACIKLAMA || ''),
          FIYAT: Number(i.FIYAT || 0),
          FIYAT_LISTESI_ID: Number(i.FIYAT_LISTESI_ID || 0),
          FIYAT_KODU: Number(i.FIYAT_KODU || 0),
        }))
        : [],

      MALZEMELER: Array.isArray(firstItem?.MALZEMELER)
        ? firstItem.MALZEMELER.map(m => ({
          MALZEME_KODU: Number(m.MALZEME_KODU),
          HIZMET_KODU: Number(m.HIZMET_KODU),
          MALZEME_STOK_NO: String(m.MALZEME_STOK_NO || ''),
          ADET: Number(m.ADET || 0),
          ACIKLAMA: String(m.ACIKLAMA || ''),
          FIYAT: Number(m.FIYAT || 0),
          FIYAT_LISTESI_ID: Number(m.FIYAT_LISTESI_ID || 0),
          FIYAT_KODU: Number(m.FIYAT_KODU || 0),
        }))
        : [],
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/GetSmsSendCheck', data, config).then((response) => {
      changeSmsKontrol(1);
      setLoadingControl(false);
      setNeedSmsResult(response.data.ReturnValue);
      setNeedSmsValidation(parseInt(response.data.SendSms, 10) === 1);

      if ((firstItem?.AramaIzin === 0 || firstItem?.AramaIzin === false) && (readonly === false)) {
        setOpenEdit(true);
        setLoadingControl(false);
        return;
      }


    }).catch(() => {
      changeSmsKontrol(0);
      setLoadingControl(false);
      setNeedSmsValidation(true);
    });



    // eslint-disable-next-line
  }, []);

  const handleChangeFarkliSms = (checked) => {
    if (readonly) {
      return;
    }

    setFarkliSms(checked);
    const jobArray = loadBaslandiJob();
    if (!Array.isArray(jobArray) || jobArray.length === 0) return;
    let job = jobArray[0];
    setAliciAd(job.SMS_ALICI_ADI || '');
    if ((job.SMS_ALICI_ADI || '').length === 0) {
      setFarkliTelAdErrorText('Alıcı Adı Girilmelidir');
    }
    setAliciSoyad(job.SMS_ALICI_SOYADI || '');
    if ((job.SMS_ALICI_SOYADI || '').length === 0) {
      setFarkliTelSoyadErrorText('Alıcı Soyadı Girilmelidir');
    }
    setAliciGsm(job.ALICI_GSM || '');
    setAliciGsmTxt(job.ALICI_GSM || '');
    job = {
      ...job,
      FARKLI_SMS: checked,
    };
    saveBaslandiJob(job);
  };
  const handleChangeAliciAdi = (event) => {
    if (readonly) {
      return;
    }

    const { value } = event.target;
    setAliciAd(value);
    if (value.length > 0) setFarkliTelAdErrorText('');
    const jobArray = loadBaslandiJob();
    if (!Array.isArray(jobArray) || jobArray.length === 0) return;
    let job = jobArray[0];
    job = {
      ...job,
      SMS_ALICI_ADI: value,
    };
    saveBaslandiJob(job);
  };
  const handleChangeSoyadi = (event) => {
    if (readonly) {
      return;
    }

    const { value } = event.target;
    setAliciSoyad(value);
    if (value.length > 0) setFarkliTelSoyadErrorText('');
    const jobArray = loadBaslandiJob();
    if (!Array.isArray(jobArray) || jobArray.length === 0) return;
    let job = jobArray[0];
    job = {
      ...job,
      SMS_ALICI_SOYADI: value,
    };
    saveBaslandiJob(job);
  };
  const handleChangeFarkliGsm = (event) => {
    if (readonly) {
      return;
    }

    const value = event.target.value.replace(/[^0-9]+/g, '');
    let jobValue = value;
    if (validPhone(value)) {
      setFarkliTelErrorText('');
      setAliciGsm(value);
      setAliciGsmTxt(value);
    } else {
      setAliciGsm('');
      setAliciGsmTxt(value);
      setFarkliTelErrorText(`Hatalı Telefon Formatı ${value} ${validPhone(value)}`);
      jobValue = '';
    }
    const jobArray = loadBaslandiJob();
    if (!Array.isArray(jobArray) || jobArray.length === 0) return;
    let job = jobArray[0];
    job = {
      ...job,
      ALICI_GSM: jobValue,
    };
    saveBaslandiJob(job);
  };
  const handleChangeSmsKod = (event) => {
    if (readonly) {
      return;
    }

    const { value } = event.target;
    setSmsKod(value);

    const jobArray = loadBaslandiJob();
    if (!Array.isArray(jobArray) || jobArray.length === 0) return;
    let job = jobArray[0];
    job = {
      ...job,
      FARKLI_SMS: farkliSms,
      SMS_ALICI_ADI: aliciAd,
      SMS_ALICI_SOYADI: aliciSoyad,
      ALICI_GSM: aliciGsm,
      ALINAN_SMS_KOD: value,
    };
    saveBaslandiJob(job);
  };

  const SmsGonder = () => {
    if (readonly) {
      return;
    }

    const jobArray = loadBaslandiJob();
    if (!Array.isArray(jobArray) || jobArray.length === 0) return;
    let job = jobArray[0];

    const phone = farkliSms ? aliciGsm : job.Telefon;
    const localSmsData = getLastSms();
    if (phone !== localSmsData?.[0]) {
      const newCode = generateCode(4);
      job = {
        ...job,
        SMS_KOD: newCode,
      }
      setLastSms(phone, newCode);
    } else {
      job = {
        ...job,
        SMS_KOD: localSmsData?.[1] || job.SMS_KOD,
      }
    }
    saveBaslandiJob(job);
    const smsText = `Sifre: ${job.SMS_KOD} ${job.Marka} Yetkili Servisinden hizmet aldığınız için teşekkür ederiz. Hizmetin tamamlanabilmesi için şifreyi servis çalışanına iletiniz.`;
    setSmsSent(true);
    const count = smsSentCount;
    setSmsSentCount(count + 1);
    axios.get(`/SmsSend/${smsText}/${phone}/${job.Marka}/${job.FisNo}/${farkliSms ? 2 : 1}/${job.SMS_KOD}`).then((response) => {


      if (JSON.stringify(response.data).includes(":true,") || JSON.stringify(response.data).toString() === "0") {
        openAlertMessage('Sms Müşteriye iletildi', 'success');
      } else {
        openAlertMessage(JSON.stringify(response.data).toString(), 'error');
      }
      setLoadingControl(false);
      setSmsSent(false);
    }).catch(() => {
      setLoadingControl(false);
      setSmsSent(false);
    });
  };




  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader title="Sms Doğrulama" />
      <div>
        <Snackbar
          autoHideDuration={3000}
          open={alertVal}
          message=""
          onClose={() => setAlertVal(false)}
        />
        {
          alertVal
          && (<Alert onClose={() => setAlertVal(false)} open={alertVal} message={alertMessage || ''} variant={alertType} />)
        }
      </div>
      <Divider />
      {
        loadingControl
        && (
          <CircularProgress
            status="loading"
            style={{ marginLeft: '50%' }}
          />
        )
      }
      <CardHeader title={<Typography variant='h6' gutterBottom>
        Müşteri Gsm
        {' '}
        <b>
          {DogrulamaData[0]?.Telefon}
        </b>
      </Typography>} />
      <Divider />
      <CardContent>
        {
          needSmsValidation
          && (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <FormControlLabel control={
                    <Checkbox
                      color="primary"
                      name="policy"
                      onChange={(e) => handleChangeFarkliSms(e.target.checked)}
                      checked={farkliSms}
                      disabled={Boolean(readonly || DogrulamaData?.[0]?.KVKK_DOGRULAMA)}
                    />
                  } label="Farklı Sms Alıcısı"
                  />
                </Grid>

              </Grid>
              {farkliSms
                && (
                  <div className={classes.fields}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          label="Alıcı Adı"
                          fullWidth
                          name="AliciAdi"
                          type="search"
                          onChange={handleChangeAliciAdi}
                          value={aliciAd}
                          disabled={readonly}
                          variant="outlined"
                          helperText={farkliTelAdErrorText}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          label="Alıcı Soyadı"
                          name="AliciSoyadi"
                          fullWidth
                          onChange={handleChangeSoyadi}
                          value={aliciSoyad}
                          disabled={readonly}
                          variant="outlined"
                          helperText={farkliTelSoyadErrorText}
                        />
                      </Grid>
                    </Grid>
                    <TextField
                      label="Alıcı Gsm"
                      name="AliciGsm"
                      fullWidth
                      placeholder="(5xx) xxx-xxxx"
                      InputProps={{
                        inputComponent: TextMaskCustom,
                      }}
                      onChange={handleChangeFarkliGsm}
                      value={aliciGsmTxt}
                      disabled={readonly}
                      variant="outlined"
                      helperText={farkliTelErrorText}
                      autoComplete="off"
                    />
                  </div>
                )}

              <div className={classes.fields}>
                <TextField
                  label="Sms Kod"
                  fullWidth
                  name="SmsKod"
                  type="search"
                  autoComplete="off"
                  value={readonly ? DogrulamaData?.[0]?.ALINAN_SMS_KOD : smsKod}
                  onChange={handleChangeSmsKod}
                  disabled={Boolean(readonly || DogrulamaData?.[0]?.KVKK_DOGRULAMA)}
                  variant="outlined"
                />
              </div>
            </form>
          )
        }
        {
          !needSmsValidation
          && (
            <Typography className={classes.title} color="textSecondary" gutterBottom>
              <b>{needSmsResult}</b>
            </Typography>
          )
        }
      </CardContent>
      <Divider />
      <CardActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={SmsGonder}
          fullWidth
          disabled={Boolean(readonly || !isButtonEnable || smsSent || DogrulamaData?.[0]?.KVKK_DOGRULAMA)}
          endIcon={<SendIcon>Gönder</SendIcon>}
        >
          {(!smsSent && ((smsSentCount > 1) ? `${smsSentCount} . kez ` : '') + 'Sms Gönder') || (smsSent && `${smsSentCount} . kez Sms Göndermek İçin Lütfen bekleyiniz`)}
        </Button>
      </CardActions>

      {!readonly && (
        <GenericAnket
          anketOpen={anketOpen}
          setAnketOpen={setAnketOpen}
          setAnketKapandi={setAnketKapandi}
          anketTitle="CRM Anketi"
          anketId={40}
          birimKodu={DogrulamaData[0]?.BIRIM_KODU}
          basvuruNo={DogrulamaData[0]?.BasvuruNo}
          setFisNo={DogrulamaData[0]?.FisNo}
        />
      )}


      <CustomerPermision
        customer={DogrulamaData === undefined ? (loadBaslandiJob()?.[0] || {}) : (DogrulamaData?.[0] || {})}
        onClose={handleEditClose}
        open={anketKapandi && openEdit}
      />
    </Card>
  );
}

Dogrulama.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  tasks: PropTypes.object,
  readonly: PropTypes.bool
};

export default connect(
  (state) => ({ tasks: state.tasks1 })
)(Dogrulama);
